import { Component, Input, OnInit } from '@angular/core';
import { FilterMatchMode } from 'primeng/api';
import { MxBaseComponent } from 'src/app/core/base/mx.base-component';
import { MxTableColumn } from 'src/app/shared/domains/common/interfaces';
import { MxColumnType } from 'src/app/shared/enums';

@Component({ standalone: false,
  selector: 'mx-table-header-cell',
  templateUrl: './mx.table-header-cell.component.html',
  styleUrls: ['./mx.table-header-cell.component.scss'],
})
export class MxTableHeaderCellComponent
  extends MxBaseComponent
  implements OnInit
{
  @Input() column: MxTableColumn;

  public get columnType(): typeof MxColumnType {
    return MxColumnType;
  }

  public get filterMatchMode(): typeof FilterMatchMode {
    return FilterMatchMode;
  }

  numberBetweenValues: number[];
  remoteSource: any[];

  ngOnInit(): void {
    if (this.column.betweenValues) {
      this.numberBetweenValues = [...this.column.betweenValues];
    }

    if (this.column.apiCall$) {
      this.column.apiCall$.subscribe((data) => {
        this.remoteSource = data;
      });
    }
  }
}
